import api from '@/apis/di/departmentAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Phòng ban
export const useDepartmentComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onDepartmentComboboxLoadData = (payload, row, column, custom, sort = '') => {
    payload.sort = sort != '' ? sort : 'department_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const departmentComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã Phòng/Ban',
        dataField: 'department_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên Phòng/Ban',
        dataField: 'department_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'department_code',
    valueField: 'department_id',
    queryMode: 'remote',
    quickSearch: 'DepartmentQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive,
    },
    dropdownWidth: 600,
    comboboxLoadData: onDepartmentComboboxLoadData,
  };

  const onDepartmentMostDetailComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'department_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let orsIsParent = [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const departmentMostDetailComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã Phòng/Ban',
        dataField: 'department_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên Phòng/Ban',
        dataField: 'department_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'department_code',
    valueField: 'department_id',
    queryMode: 'remote',
    quickSearch: 'DepartmentQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    dropdownWidth: 600,
    comboboxLoadData: onDepartmentMostDetailComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    departmentComboConfig,
    onDepartmentComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid,
    departmentMostDetailComboConfig,
    onDepartmentMostDetailComboboxLoadData,
  };
};
